import { UserState } from "../reducers/user";

export function userIsEmployer(user: UserState) {
  return user.role_id === 2;
}